import React from 'react';
import PropTypes from 'prop-types';

import { pluralizeObject, Brandfolder } from '@helpers/show_page_helpers';
import CustomFieldsInputRow from '@components/show_page/bulk_actions/sub_components/custom_fields_input_row';

class BulkCustomFieldsModal extends React.Component {
  state = {
    validFields: false,
    existingCustomFields: [],
    stagedCustomFields: {},
    visibleRows: 0,
    deletedRows: []
  }

  componentDidMount() {
    this.fetchExistingCustomFieldKeys();
  }

  updateStagedCustomFields = (position, key, value) => {
    if (key && key.trim().length && value && value.trim().length) {
      this.setState((prevState) => ({
        stagedCustomFields: Object.assign(prevState.stagedCustomFields,
          { [position]: { [key]: value } })
      }), this.validateFields);
    } else {
      this.setState((prevState) => {
        const updatedFields = Object.assign({}, prevState.stagedCustomFields);
        delete updatedFields[position];
        return { stagedCustomFields: updatedFields };
      }, this.validateFields);
    }
  }

  elminateRow = (position) => {
    this.setState((prevState) => {
      const remainingRows = Object.assign({}, prevState.stagedCustomFields);
      delete remainingRows[position];
      return {
        stagedCustomFields: remainingRows,
        deletedRows: prevState.deletedRows.concat(position)
      };
    }, this.validateFields);
  }

  controlledFieldsEnabled = (keys) => (
    (BFG.context.brandfolderSettings
      && BFG.context.brandfolderSettings.controlled_custom_fields_enabled
        && !!(keys || this.state.existingCustomFields).find((customFieldKey) => (
          customFieldKey.attributes.restricted)))
  )

  validateFields() {
    const { stagedCustomFields, visibleRows, deletedRows } = this.state;
    const values = Object.values(stagedCustomFields);
    const isValid = (values.length === (visibleRows - deletedRows.length)
      || this.controlledFieldsEnabled()) && values.length > 0;
    this.setState({ validFields: isValid });
  }

  fetchExistingCustomFieldKeys() {
    $.ajax({
      type: 'GET',
      url: `/api/v4/brandfolders/${Brandfolder.key}/custom_field_keys?fields=values`,
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      context: this,
      success: (response) => {
        const keysSortedByName = response.data.sort((a, b) => (
          a.attributes.name.toLowerCase() < b.attributes.name.toLowerCase() ? -1 : 1));
        this.setState((prevState) => ({
          existingCustomFields: keysSortedByName,
          visibleRows: this.controlledFieldsEnabled(response.data)
            ? response.data.length
            : prevState.visibleRows + 1 }));
      },
      error: () => {
      }
    });
  }

  submitCustomFields() {
    const { selectedAssetKeys } = this.props;
    const { stagedCustomFields } = this.state;
    const postData = {
      data: {
        asset_keys: Array.from(selectedAssetKeys),
        management_action: "create",
        brandfolder_key: Brandfolder.key,
        custom_fields: Object.values(stagedCustomFields)
      }
    };
    $.ajax({
      type: 'POST',
      url: "/api/v4/bulk_actions/assets/manage_custom_fields",
      contentType: 'application/json',
      headers: { Authorization: `Bearer ${BF_Token}` },
      data: JSON.stringify(postData),
      context: this,
      success: () => {
        Notify.create({
          type: "success",
          title: "Processing Custom Field Updates!",
          body: `Updating/Adding ${Object.values(stagedCustomFields).length}
            Custom Field${Object.values(stagedCustomFields).length > 1 ? "s" : ""} for
            ${selectedAssetKeys.size} Asset${(selectedAssetKeys.size > 1) ? "s" : ""}` });
        this.props.closeModal();
      },
      error: () => {
        Notify.create({ type: "error", title: "Please try again!" });
      }
    });
  }

  render() {
    const assetQtyObject = pluralizeObject(this.props.selectedAssetKeys);
    const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');
    const { validFields, existingCustomFields, visibleRows, deletedRows } = this.state;
    const customFieldCount = Object.keys(this.state.stagedCustomFields).length;
    return (
      <div className="modal-content-wrapper bulk-custom-fields-modal">
        <div className="modal-content-wrapper__body">
          <h3 className="body-title">
            {t('Add custom fields to')}
            <span className="bold-text">{assetQtyObject.qty} {assetCopy}</span>
          </h3>
          <div className="labels-container">
            <div className="labels-row">
              <span className="row-header">Key</span>
              <span className="row-header">Value</span>
            </div>
            { [...Array(visibleRows)].map((_, i) => {
              if (deletedRows.includes(i)) { return null; }
              return (
                <CustomFieldsInputRow
                  key={`custom-fields-inputs-${i}`}
                  existingCustomFields={existingCustomFields}
                  updateStagedCustomFields={this.updateStagedCustomFields}
                  position={i}
                  eliminateRow={this.elminateRow}
                  controlledFields={this.controlledFieldsEnabled()}
                />
              );
            })}
            { !this.controlledFieldsEnabled() ? (
              <div
                className="add-new-row"
                onClick={() => this.setState((prevState) => (
                  { visibleRows: prevState.visibleRows + 1 }), this.validateFields)}
              >
                <span className="bff-plus" />
                <span>Add another custom field</span>
              </div>
            ) : null }
          </div>
          <div className="button-container">
            <button
              className="button tertiary sm t-close-modal"
              onClick={this.props.closeModal}
              type="button"
            >
              {t('Cancel')}
            </button>
            <button
              className="button primary lg t-confirm-modal"
              disabled={!validFields}
              onClick={() => this.submitCustomFields()}
              type="button"
            >
              {t(`Add ${(customFieldCount > 0) ? customFieldCount : ""}
                Custom Field${(customFieldCount > 1) ? "s" : ""}`)}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

BulkCustomFieldsModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

export default BulkCustomFieldsModal;
